import styles from "./Tag.module.css";

export const Tag = ({
  children,
  ...props
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return (
    <span className={styles.tag} {...props}>
      {children}
    </span>
  );
};
